import * as Types from './messaging_gql.generated';

import { MessageFragment, ConversationFragment, CoachFragment, MemberFragment } from './fragments.generated';
import { gql } from 'graphql.macro';
import { MessageFragmentDoc, ConversationFragmentDoc, CoachFragmentDoc, MemberFragmentDoc } from './fragments.generated';
import * as Apollo from '@apollo/client';
export type GetMessagesQueryVariables = Types.Exact<{
  conversationUuid: Types.Scalars['UUID'];
  active?: Types.Maybe<Types.Scalars['Boolean']>;
  count?: Types.Maybe<Types.Scalars['Int']>;
  after?: Types.Maybe<Types.Scalars['UUID']>;
  includeConversation?: Types.Maybe<Types.Scalars['Boolean']>;
}>;


export type GetMessagesQuery = (
  { __typename?: 'Queries' }
  & { getMessages?: Types.Maybe<(
    { __typename?: 'MessagesNode' }
    & { messages?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'MessageNode' }
      & MessageFragment
    )>>>, pageInfo?: Types.Maybe<(
      { __typename?: 'PageInfoNode' }
      & Pick<Types.PageInfoNode, 'oldestMessageUuid'>
    )> }
  )>, conversations?: Types.Maybe<(
    { __typename?: 'ConversationsRelayNode' }
    & { edges?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'ConversationEdgeRelayNode' }
      & Pick<Types.ConversationEdgeRelayNode, 'cursor'>
      & { node?: Types.Maybe<(
        { __typename?: 'ConversationNode' }
        & ConversationFragment
      )> }
    )>>> }
  )> }
);


export const GetMessagesDocument = gql`
    query getMessages($conversationUuid: UUID!, $active: Boolean, $count: Int, $after: UUID, $includeConversation: Boolean = false) {
  getMessages(conversationUuid: $conversationUuid, perPage: $count, after: $after) {
    messages {
      ...message
    }
    pageInfo {
      oldestMessageUuid
    }
  }
  conversations(active: $active, uuid: $conversationUuid) @include(if: $includeConversation) {
    edges {
      cursor
      node {
        ...conversation
      }
    }
  }
}
    ${MessageFragmentDoc}
${ConversationFragmentDoc}
${CoachFragmentDoc}
${MemberFragmentDoc}`;
export type GetMessagesQueryResult = Apollo.QueryResult<GetMessagesQuery, GetMessagesQueryVariables>;